
export default function About() {
  return (
    <section id="about" className="py-32 px-8 lg:px-16 bg-[#F5F3F0]">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center">
        <div className="w-full h-[500px] flex items-center justify-center bg-white rounded-lg">
          <div className="text-center">
            <div className="mb-4">
              <svg className="w-32 h-32 mx-auto" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="100" cy="100" r="80" stroke="#8B7355" strokeWidth="2" fill="none"/>
                <circle cx="100" cy="100" r="60" stroke="#8B7355" strokeWidth="1.5" fill="none"/>
                <path d="M100 40 L100 160 M40 100 L160 100" stroke="#8B7355" strokeWidth="1" opacity="0.3"/>
                <circle cx="100" cy="70" r="8" fill="#8B7355"/>
                <circle cx="100" cy="100" r="12" fill="#8B7355"/>
                <circle cx="100" cy="130" r="8" fill="#8B7355"/>
              </svg>
            </div>
            <h1 className="text-4xl font-light text-[#2C2C2C] mb-2" style={{ fontFamily: 'Georgia, serif', letterSpacing: '0.05em' }}>
              OXYZEN
            </h1>
            <div className="w-24 h-px bg-[#8B7355] mx-auto my-3"></div>
            <p className="text-lg font-light text-[#6B5E52]" style={{ fontFamily: 'Georgia, serif', letterSpacing: '0.1em' }}>
              BEAUTY & WELLNESS
            </p>
          </div>
        </div>

        <div>
          <h2 className="text-4xl lg:text-5xl font-light text-[#2C2C2C] mb-8" style={{ fontFamily: 'Georgia, serif' }}>
            Healing Through Touch
          </h2>
          <p className="text-base text-[#6B6B6B] leading-relaxed mb-6">
            At our massage therapy practice, we believe in the transformative power of therapeutic touch. Each session is carefully crafted to address your unique needs, whether you seek relief from tension, recovery from injury, or simply a moment of deep relaxation.
          </p>
          <p className="text-base text-[#6B6B6B] leading-relaxed">
            Our certified massage therapists combine traditional techniques with modern wellness practices to create a healing experience that nurtures both body and spirit. Step into our tranquil space and let us guide you on a journey to renewed vitality and inner peace.
          </p>
        </div>
      </div>
    </section>
  );
}
